import React from 'react';
import AdminPanel from '../../components/admin-panel/admin-panel';

const AdminPanelPage = () => {
  return <AdminPanel />;
};

export default AdminPanelPage;
